import { rules } from '../../../../modules/FormItems'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'
import { Col, Form, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'
import { compose } from 'recompose'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import withKeyValue from '../../../../elements/HOC/WithKeyValue'
import withSort from '../../../../elements/HOC/withSort'

const TypesSelect = compose(
  withData({
    data: ['Earning', 'Reimbursement', 'Deduction', 'Contribution', 'Repayment'],
  }),
  withKeyValue(),
  withSort,
)(CustomSelect)

function SalaryLinesForm (props) {
  const { line, salary, list } = props
  const { getFieldDecorator, getFieldValue } = props.form

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Name'}>
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.input,
            })(<Input placeholder={'Name'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Type'}>
            {getFieldDecorator('type', {
              initialValue: get(line, 'type'),
              rules: rules.input,
            })(<TypesSelect placeholder={'Type'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Account'}>
            {getFieldDecorator('accounts', {
              initialValue: get(line, 'accounts'),
              // rules: rules.select,
            })(<Input placeholder={'Account'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Amount'}>
            {getFieldDecorator('amount', {
              initialValue: get(line, 'amount'),
              rules: rules.input,
            })(<InputNumber placeholder={'Amount'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

SalaryLinesForm.propTypes = {}
SalaryLinesForm.defaultProps = {}

export default Form.create()(SalaryLinesForm)
